var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79169 14.1667C11.3125 14.1667 14.1667 11.3125 14.1667 7.79166C14.1667 4.27085 11.3125 1.41666 7.79169 1.41666C4.27087 1.41666 1.41669 4.27085 1.41669 7.79166C1.41669 11.3125 4.27087 14.1667 7.79169 14.1667Z",
    stroke: "#001F54",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4087 14.6553C13.7841 15.7886 14.6412 15.902 15.3 14.9103C15.902 14.0036 15.5054 13.2599 14.4145 13.2599C13.607 13.2528 13.1537 13.8832 13.4087 14.6553Z",
    stroke: "#001F54",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.79a45645ad9ec60640645864b2d46436.svg";
export { ForwardRef as ReactComponent };